import Faq from "./faq.js";

export default Faq;
